import { DateTime } from 'luxon';

/**
 * Get the TMT month end
 *
 * @param date Any date in the month
 */
export function getTMTMonthEnd(date: DateTime, recursion?: boolean) {
  // TMT never pay on the last day, so if it's the last day we subtract by one
  const tryFrom = recursion ? date : date.endOf('month').minus({ day: 1 });

  // TMT Payout days are currently Thursday and Sunday.
  // https://moment.github.io/luxon/api-docs/index.html#datetimeweekday
  // https://en.wikipedia.org/wiki/ISO_week_date
  const thursday = 4;
  const sunday = 7;

  // If the TMT month end, return the date
  if ([thursday, sunday].includes(tryFrom.weekday)) {
    return tryFrom;
  }

  // Otherwise subtract a day and check again (recursively)
  return getTMTMonthEnd(tryFrom.minus({ day: 1 }), true);
}

/**
 * Get the TMT month start
 *
 * @param date Any date in the month
 */
export function getTMTMonthStart(date: DateTime) {
  const previousMonthEnd = date.endOf('month').minus({ month: 1 });
  return getTMTMonthEnd(previousMonthEnd).plus({ day: 1 }).startOf('day');
}

/**
 * Create months list
 */
export default function createMonthsList(): Array<{
  startDate: DateTime;
  endDate: DateTime;
}> {
  // Show statements from 2021 up to now
  const lastMonth = DateTime.utc().minus({ month: 1 });
  const firstDate = DateTime.fromISO('2022-01-01T00:00:00.000Z');

  const monthsList: Array<{ startDate: DateTime; endDate: DateTime }> = [
    {
      startDate: getTMTMonthStart(lastMonth),
      endDate: getTMTMonthEnd(lastMonth),
    },
  ];

  while (monthsList[monthsList.length - 1].startDate > firstDate) {
    const minusMonth = monthsList[monthsList.length - 1].endDate.minus({
      month: 1,
    });

    monthsList.push({
      startDate: getTMTMonthStart(minusMonth),
      endDate: getTMTMonthEnd(minusMonth),
    });
  }

  return monthsList;
}
